export class AutomatVpos {
    constructor() {
    }

    _id?: string;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/automatVpos.ts